// Azure AD App Registration values for FieldApp Admin SSO
export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_AD_CLIENT_ID, // Azure AD Application (client) ID from env
    authority: process.env.REACT_APP_AZURE_AUTHORITY, // Azure AD Directory (tenant) ID from env
    redirectUri: window.location.origin + "/auth-callback" // Use dedicated callback route
  },
  cache: {
    cacheLocation: "sessionStorage", // Use sessionStorage for MSAL cache (persistent across reloads)
    storeAuthStateInCookie: false
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        // Optionally log MSAL messages in development, or silence in production
        if (process.env.NODE_ENV === "development") {
          console.log("MSAL LOG:", message);
        }
      },
      logLevel: 3, // Info
      piiLoggingEnabled: false
    }
  }
};
